<template>
    <v-container class="padding-top-0 pl-0 pb-0" id="detail-product">
        <v-row>
            <v-col cols="12" class="padding-top-0 pb-0 pl-0 pr-0">
                <v-card outlined class="card-no-border">
                    <v-card-text class="padding-top-0 pb-0 pl-0 pr-0">
                        <v-container>
                            <v-row>
                                <v-col :md="8" :sm="12" cols="12" class="padding-top-0">
                                    <div >
                                        <div>
                                            <h1>Pedido</h1>
                                        </div>
                                        <div>
                                            <span>#{{ order.id | numberOrder }}</span>
                                        </div>
                                        <div class="pt-3">
                                            <span :class="'order-selected-status order-selected-status-' + order.status.toLowerCase().replace(' ', '-')">
                                                <v-icon size="8" class="mr-1" color="white">fas fa-circle</v-icon>{{ order.status | uppercase  }}
                                            </span>
                                        </div>
                                        <div>
                                            <template>
                                                <v-row>
                                                    <v-col :md="6" :sm="6" cols="12" class="padding-top-0 pb-0">
                                                            <v-list-item two-line class="pl-0">
                                                                <v-list-item-avatar>
                                                                    <v-icon size="17" class="grey lighten-1 white--text">far fa-file-alt</v-icon>
                                                                </v-list-item-avatar>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>
                                                                        <span class="font-weight-medium">FECHA DE PEDIDO</span>
                                                                    </v-list-item-title>
                                                                    <v-list-item-subtitle>
                                                                        <span>{{ order.entry_time | moment("DD MMM YYYY, h:mm:ss a") }}</span>
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>                                                    
                                                            </v-list-item>
                                                    </v-col>
                                                    <v-col :md="6" :sm="6" cols="12" class="padding-top-0 pb-0">
                                                        <v-list-item two-line class="pl-0">
                                                            <v-list-item-avatar>
                                                                <v-icon size="17" class="grey lighten-1 white--text">fas fa-truck</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                    <span class="font-weight-medium">FECHA DE ENTREGA</span>
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle>
                                                                    <span v-if="order.delivery_time===null">
                                                                        Pendiente
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ order.delivery_time | moment("DD MMM YYYY, h:mm:ss a") }}
                                                                    </span>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>                                                    
                                                        </v-list-item>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </div>
                                        <!--
                                        <div>
                                            <template>
                                                <v-row>
                                                    <v-col :md="5" :sm="5" cols="12" class="pt-3">
                                                        <v-autocomplete
                                                            label="Repartidor Asignado"
                                                            :items="deliveryUsers"
                                                            :item-text="customTextDelivery"
                                                            :value="deliveryman"
                                                            @input="setDeliveryman"
                                                            hide-details
                                                            dense
                                                            outlined
                                                            clearable
                                                            clear-icon="far fa-times-circle"
                                                            item-value="id"
                                                            @change="handleSelectDeliveryMan">
                                                            <template v-slot:item="data">
                                                                    <v-list-item-content class="pt-1 pb-1">
                                                                        <v-list-item-title>{{ data.item.fullname }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action class="mt-1 mb-1">
                                                                        <v-chip v-if="data.item.slopes==0" class="ma-2" x-small>
                                                                            {{ data.item.slopes }}
                                                                        </v-chip>
                                                                        <v-chip v-else class="ma-2" color="red" text-color="white" x-small>
                                                                            {{ data.item.slopes }}
                                                                        </v-chip>
                                                                    </v-list-item-action>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col v-if="order.status.toLowerCase() !== 'registrado'" :md="5" :sm="5" cols="12" class="pt-3">
                                                        <v-autocomplete
                                                            label="Repartidor Final"
                                                            :items="deliveryUsers"
                                                            :item-text="customTextDelivery"
                                                            :value="finalDeliveryman"
                                                            @input="setFinalDeliveryman"
                                                            hide-details
                                                            dense
                                                            outlined
                                                            clearable
                                                            clear-icon="far fa-times-circle"
                                                            item-value="id"
                                                            @change="handleSelectFinalDeliveryMan">
                                                            <template v-slot:item="data">
                                                                    <v-list-item-content class="pt-1 pb-1">
                                                                        <v-list-item-title>{{ data.item.fullname }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action class="mt-1 mb-1">
                                                                        <v-chip v-if="data.item.slopes==0" class="ma-2" x-small>
                                                                            {{ data.item.slopes }}
                                                                        </v-chip>
                                                                        <v-chip v-else class="ma-2" color="red" text-color="white" x-small>
                                                                            {{ data.item.slopes }}
                                                                        </v-chip>
                                                                    </v-list-item-action>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col v-if="order.status.toLowerCase() === 'en reparto' && finalDeliveryman > -1" 
                                                        :md="2" :sm="2" cols="12" class="pt-3 pl-0">
                                                        <v-btn small dark color="blue darken-1" 
                                                            @click="handleAssingFinalDeliveryMan()" height="40"
                                                            v-if="verifyPermission('reasignar_repartidor_venta')">
                                                            Reasignar
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </div> 
                                        -->
                                    </div>
                                </v-col>                                
                                <v-col :md="4" :sm="12" cols="12" class="padding-top-0">
                                    <v-card class="card-shipping">
                                        <v-card-title>
                                            <v-icon class="mr-2" color="blue">fas fa-user-tag</v-icon>
                                            <span>CLIENTE</span>                                            
                                        </v-card-title>
                                        <v-card-text>
                                            <span class="send-name font-weight-bold">
                                                {{ order.customer.name }} {{ order.customer.surname }}
                                            </span>
                                            <span>
                                                Teléfono: {{ order.customer.phone }}
                                            </span>
                                            <span class="send-address mb-2">
                                                Dirección: {{ order.customer.address }} - {{ order.customer.district }}
                                            </span>
                                            <v-divider></v-divider>
                                            <span class="balance-favor mt-2">
                                                Saldo a favor: <span style="color: #1B5E20;font-weight: bold;">{{ order.customer.balance_favor | currency('S/ ') }}</span>
                                            </span>
                                            <span class="drums">
                                                Bidones no devueltos: <span style="color: #F44336;font-weight: bold;">{{ order.customer.pending_drums }}</span>
                                            </span>
                                            <span class="customer-debt">
                                                Deuda: <span style="color: #F44336;font-weight: bold;">{{ debt_customer | currency('S/') }}</span>
                                            </span>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col cols="12" class="padding-top-1 pt-0">
                <list-products></list-products>
            </v-col>
        </v-row>
    </v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import ListProducts from './ListProducts'
import OrdersTools from '../../helpers/OrdersTools.js'

import {APIService} from '@/APIService';

const apiService = new APIService();

export default {
    name: 'DetailOrder',
    components: {
        ListProducts
    },
    computed: {
        ...mapState('orders', [
            'order',
            'listStatus',
            'deliveryUsers',
            'deliveryman',
            'finalDeliveryman',
            'debt_customer'
        ]),
    },
    methods: {
        ...mapActions('orders', [
            'selectOrder',
            'getDeliveryUsers',
            'assignDeliveryman',
            'assignFinalDeliveryman',
            'getAvailableStatus',
            'replaceOrderUpdated'
        ]),
        ...mapMutations('orders', [
            'setDeliveryman',
            'setFinalDeliveryman'
        ]),
        customTextDelivery(item){
            let text = item.fullname
            return text
        },
        handleSelectDeliveryMan(value) {
            if (value === undefined) {
                this.assignDeliveryman(-1)
            }else {
                this.assignDeliveryman(value)
            }
        },
        handleSelectFinalDeliveryMan(value) {
            if (value === undefined) {
                this.assignFinalDeliveryman(-1)
            } else {
                this.assignFinalDeliveryman(value)
            }            
        },
        handleAssingFinalDeliveryMan(){
            let orderChange = {
                order_id: this.order.id,
                final_deliveryman: this.finalDeliveryman
            }
            apiService.assingFinalDeliveryMan(orderChange).then((response) => {
                this.selectOrder(null)
                this.getDeliveryUsers()
                this.selectOrder(response.data)
                this.getAvailableStatus()                
                if (this.order.final_deliveryman !== null) {
                    this.assignFinalDeliveryman(this.order.final_deliveryman)
                } else {
                    this.assignFinalDeliveryman(-1)
                }
                this.replaceOrderUpdated()
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'RESULTADO DE ACCIÓN REALIZADA',
                    text: 'La reasignación de repartidor se realizó de manera correcta!'
                });
            });
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getDeliveryUsers()
    }
}
</script>

<style scope>

.card-no-border{
    border: 0px !important;
}

.order-selected-status{
    display: block;
    padding: 2px;
    border-radius: 4px;
    width: 140px;
    text-align: center;
    font-size: .8rem;
}

.send-name{
    display: block;
    color: #303F9F;
}

.send-address{
    display: block;
}

.card-shipping{
    height: 100%;
}

.balance-favor{
    display: block;    
}

.customer-debt{
    display: block;
}
</style>